export class MenuItemsRequest{
    boxSize: number;
    content: string;
    expirationDate: string;
    externalLink:string
    index: number;
    listTitle:string;
    menuId: number;
    title: string;
    
}

export class MenuItemsRequestList{
    dimPagina: number;
    numeroPagina: number;
    
}

export class MenuItemsRequestCreate extends MenuItemsRequest{
    constructor(){super();}
}

export class MenuItemsRequestUpdate extends MenuItemsRequest{
    constructor(){super();}
}

export class MenuItemRequestPublish{
    id:number;
    published:boolean;
    
}

export class MenuItemsRequestSearch{
    content: string;
    pageNumber: number;
    pageSize: number;
    published: boolean;
    sortBy: string;
    title: string;   
}